export class Email {
	constructor(
		public id?: number,
		public email?: string,
		public cc?: string,
		public cco?: string,
		public subject?: string,
		public content?: string,
		public attachments?: Array<any>,
	) { }
}